import { Client } from '@/common/services/Client';

export async function exportComparatorExcel(
  renewalUuid: string,
): Promise<Blob> {
  const response = await Client.get<Blob>({
    endpoint: `/comparator/${renewalUuid}/export/excel`,
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'blob',
  });

  return response.data;
}
